/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface AdminGetUsersDataElementDto
 */
export interface AdminGetUsersDataElementDto {
    /**
     * 유저 uuid
     * @type {string}
     * @memberof AdminGetUsersDataElementDto
     */
    'userUuid': string;
    /**
     * 아이디
     * @type {string}
     * @memberof AdminGetUsersDataElementDto
     */
    'id': string;
    /**
     * 이름
     * @type {string}
     * @memberof AdminGetUsersDataElementDto
     */
    'name': string;
    /**
     * 성별
     * @type {string}
     * @memberof AdminGetUsersDataElementDto
     */
    'gender': AdminGetUsersDataElementDtoGenderEnum;
    /**
     * 생년월일
     * @type {string}
     * @memberof AdminGetUsersDataElementDto
     */
    'birthdate': string;
    /**
     * 유저 레벨
     * @type {string}
     * @memberof AdminGetUsersDataElementDto
     */
    'level'?: AdminGetUsersDataElementDtoLevelEnum;
    /**
     * 서포터즈 여부
     * @type {boolean}
     * @memberof AdminGetUsersDataElementDto
     */
    'isSupporter'?: boolean;
    /**
     * 수호신 여부
     * @type {boolean}
     * @memberof AdminGetUsersDataElementDto
     */
    'isGuardian'?: boolean;
    /**
     * 관리자의 해당 유저 즐겨찾기 여부
     * @type {boolean}
     * @memberof AdminGetUsersDataElementDto
     */
    'isStarred'?: boolean;
    /**
     * 관리자의 해당 유저 차단 여부
     * @type {boolean}
     * @memberof AdminGetUsersDataElementDto
     */
    'isBanned'?: boolean;
    /**
     * 관리자의 유저 메모
     * @type {string}
     * @memberof AdminGetUsersDataElementDto
     */
    'memo': string;
    /**
     * 현재 유저의 총 포인트
     * @type {number}
     * @memberof AdminGetUsersDataElementDto
     */
    'totalPoint'?: number;
    /**
     * 총 환급 포인트
     * @type {number}
     * @memberof AdminGetUsersDataElementDto
     */
    'totalExchangedPoint'?: number;
    /**
     * 누적 획득 총 포인트
     * @type {number}
     * @memberof AdminGetUsersDataElementDto
     */
    'earnedPoint'?: number;
    /**
     * 최종 접속 일시
     * @type {string}
     * @memberof AdminGetUsersDataElementDto
     */
    'lastAccessedAt': string;
    /**
     * 생성 일시
     * @type {string}
     * @memberof AdminGetUsersDataElementDto
     */
    'createdAt': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminGetUsersDataElementDto
     */
    'viewupSnsAccountsCounts': Array<string>;
}

export const AdminGetUsersDataElementDtoGenderEnum = {
    M: 'M',
    F: 'F',
    Unknown: 'unknown'
} as const;

export type AdminGetUsersDataElementDtoGenderEnum = typeof AdminGetUsersDataElementDtoGenderEnum[keyof typeof AdminGetUsersDataElementDtoGenderEnum];
export const AdminGetUsersDataElementDtoLevelEnum = {
    Baby: 'baby',
    Friends: 'friends',
    Family: 'family',
    Supporters: 'supporters',
    Guardian: 'guardian',
    Both: 'both'
} as const;

export type AdminGetUsersDataElementDtoLevelEnum = typeof AdminGetUsersDataElementDtoLevelEnum[keyof typeof AdminGetUsersDataElementDtoLevelEnum];


